import { Container } from 'components/container'
import styled, { css } from 'styled-components/macro'
import { mq } from 'styles/mq'

export const ObservedPoint = styled.div.attrs({ 'aria-hidden': true })`
  position: absolute;
  top: 0;
  left: 0;
  width: 1rem;
  height: 1rem;
`

export const Buttons = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  overflow: hidden;

  a {
    display: flex;
  }

  ${mq.medium} {
    display: contents;
  }
`

export const Bar = styled.div<{ $isOpaque: boolean }>`
  position: sticky;
  bottom: 1.2rem;
  width: 100%;
  padding: 0.4em 0;
  margin: 1.2rem 0;
  text-align: center;
  font-weight: 700;
  font-size: 1.4rem;
  transition: all 0.2s;
  background-color: white;
  z-index: 1000;

  ${mq.smallOnly} {
    bottom: 0;

    br {
      display: none;
    }

    ${Buttons} {
      margin-top: -0.5em;
    }
  }

  ${mq.medium} {
    margin-top: 10rem;
    font-size: 1.6rem;

    br {
      display: none;
    }
  }

  ${Container} {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;

    ${mq.medium} {
      gap: 1.8rem;
    }
  }

  ${props =>
    props.$isOpaque &&
    css`
      color: white;
      background-color: transparent;

      ${mq.smallOnly} {
        font-size: 1.6rem;

        br {
          display: block;
        }

        ${Buttons} {
          margin-block: 0.3em;
        }
      }

      ${mq.medium} {
        bottom: 3rem;
      }

      ${mq.smallOnly} {
        position: sticky;
        bottom: 1.2rem;
        left: 0;
        margin-top: 10rem;
      }
    `}

  p {
    margin: 0 0 0.5em;

    ${mq.smallOnly} {
      display: flex;
    }

    ${mq.medium} {
      margin: 0 1em 0 0;
    }
  }

  svg {
    display: inline-block;
    vertical-align: middle;
    margin: 0.4rem;

    ${mq.smallOnly} {
      width: 100%;
    }

    ${mq.medium} {
      margin: 0;
    }
  }
`

export const LG = styled.p`
  font-weight: normal;
  font-size: 0.8em;
  opacity: 0.7;
`
